import { render, staticRenderFns } from "./filtered.vue?vue&type=template&id=028c6a00&"
import script from "./filtered.vue?vue&type=script&lang=js&"
export * from "./filtered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports